module.exports = __webpack_public_path__ + "img/blue.df29f00d.png";